import inst from '@/backend/axios-instances'

const instance = inst.baseInstance
const resource = '/admin'

export default {
  registerUser(data) {
    return instance.post(`${resource}/registeruser`, data);
  }
}
